export default __webpack_public_path__ + "alberta-diabetes.3d3cbe3d64b96fc0b6f4.svg";